import { render, staticRenderFns } from "./VasionListSelection.vue?vue&type=template&id=13c31957&scoped=true&"
import script from "./VasionListSelection.vue?vue&type=script&lang=js&"
export * from "./VasionListSelection.vue?vue&type=script&lang=js&"
import style0 from "./VasionListSelection.vue?vue&type=style&index=0&id=13c31957&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c31957",
  null
  
)

export default component.exports